import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-md-10 col-lg-8 col-xl-6 mx-auto header" }
const _hoisted_3 = { class: "answers" }
const _hoisted_4 = ["name", "id", "value"]
const _hoisted_5 = ["for"]
const _hoisted_6 = {
  key: 1,
  class: "row"
}
const _hoisted_7 = { class: "col-xl-9 mx-auto header" }
const _hoisted_8 = {
  key: 2,
  class: "text-start mt-4"
}
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_low_cost_drawdown = _resolveComponent("low-cost-drawdown")!
  const _component_simple_comparison = _resolveComponent("simple-comparison")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showQuestions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "skin-page-heading" }, "Providers", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "question" }, "Tell us what is most important to you for choosing a provider to use in retirement", -1)),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answers, (answer, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "form-check shadow-sm d-flex align-self-center"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input d-flex align-self-center",
                    type: "radio",
                    name: `flexRadioDefault${_ctx.questionId}`,
                    id: `flexRadioDefault${_ctx.questionId}${i}`,
                    value: i,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.questionResponses[_ctx.questionId]) = $event))
                  }, null, 8, _hoisted_4), [
                    [_vModelRadio, _ctx.questionResponses[_ctx.questionId]]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: `flexRadioDefault${_ctx.questionId}${i}`
                  }, _toDisplayString(answer), 9, _hoisted_5)
                ]))
              }), 128))
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onContinueClick && _ctx.onContinueClick(...args)))
              }, " Continue ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showProviders)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.outcome == _ctx.Outcome.LowCostDrawdown)
              ? (_openBlock(), _createBlock(_component_low_cost_drawdown, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.outcome == _ctx.Outcome.SimpleComparison)
              ? (_openBlock(), _createBlock(_component_simple_comparison, { key: 1 }))
              : _createCommentVNode("", true),
            (_ctx.showReferralSmallPrint)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[5] || (_cache[5] = [
                  _createElementVNode("p", { class: "text-muted" }, [
                    _createElementVNode("small", null, [
                      _createTextVNode(" Disclaimer - We do not take any referral fees from any providers above. Some providers may license our tools for their own use, so we do have commercial relationships. You can seek other providers on your own or get independent financial advice to find the most appropriate. You can do this via our Advisers page, or go to "),
                      _createElementVNode("a", {
                        href: "https://www.moneyhelper.org.uk",
                        target: "_blank"
                      }, "moneyhelper.org.uk"),
                      _createTextVNode(" if you want more help on finding an adviser. ")
                    ])
                  ], -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.showBackButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, [
                    _createElementVNode("a", {
                      href: "",
                      class: "btn btn-outline-dark",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onBackToQuestionsClick($event)))
                    }, _cache[6] || (_cache[6] = [
                      _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1),
                      _createTextVNode(" Back ")
                    ]))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}